import { Component, inject } from '@angular/core';
import { FeedbackService } from '../services/feedback.service';
import { Feedback } from '../models/feedback';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.css',
    imports: [RouterLink, FormsModule]
})
export class FeedbackComponent {

  private feedbackService = inject(FeedbackService);

  feedback: Feedback = { message: '', email: '' };
  submitted = false;

  submit() {
    this.feedbackService.post(this.feedback).subscribe(() => this.submitted = true);
  }

}
